export default __webpack_public_path__ + "static/media/Background_00287.1b280771.png";